<div
  *ngIf="item"
  [class.active]="item.state"
  (click)="openModal()"
  [class.toggle-disabled]="isDisabled"
  class="switch">
  <div class="switch__decor">
    <img *ngIf="isDisabled" src="assets/img/lock-state.svg" alt="">
  </div>
  <div class="switch__tooltip">
    <span
      *ngIf="!item.state"
      [class.message-disabled]="isDisabled"
      class="switch__tooltip-text">
      {{onName}}
    </span>
    <span
      *ngIf="item.state"
      [class.message-disabled]="isDisabled"
      class="switch__tooltip-text">
      {{offName}}
    </span>
    <span
      *ngIf="isDisabled"
      class="switch__tooltip-text">
      {{disabledTooltip}}
    </span>
  </div>
</div>

<app-modal
  [(isOpenModal)]="isOpenDialog">
  <app-switch-confirm-dialog
    [header]="header"
    [description]="description"
    [buttonText]="buttonText"
    (onConfirm)="changeState()"
    [state]="item.state">
  </app-switch-confirm-dialog>
</app-modal>
